import Vue from 'vue';
import Vuex from 'vuex';

import search from './products/search';
import cart from './cart/index';
import compare from './products/compare';

import config from '../config';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    isLoading: true,
  },
  modules: {
    search,
    cart,
    compare,
  },
  mutations: {
    FINISH_LOADING(state) {
      state.isLoading = false;
    },
  },
  actions: {
    finishLoading({ commit }) {
      commit('FINISH_LOADING');
    },
  },
});

// we need to load data at the initialization
store.dispatch('cart/getCurrentOrder');
store.dispatch('search/setLocale', config.locale);
store.commit('search/UPDATE_PROPERTIES_FILTERS', config.propertyFilters);
store.commit('search/UPDATE_OPTIONS_FILTERS', config.optionFilters);

export default store;
